import { Directive, Input, ElementRef, Renderer2, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Directive({
  selector: '[appActiveLink]'
})
export class ActiveLinkDirective implements OnInit {
  @Input() appActiveLink: string;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private router: Router
  ) {}

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.router.url.includes(this.appActiveLink)) {
          this.renderer.addClass(this.el.nativeElement, 'active-list-item');
        } else {
          this.renderer.removeClass(this.el.nativeElement, 'active-list-item');
        }
      }
    });
  }
}
